import React from 'react';
import {useSelector} from 'react-redux';
import cx from 'classnames';
import {Card} from '~/common/canvas/Card/Card';
import {useInMwEditDesignButtonAbTest} from '~/common/hooks/useInMwEditDesignButtonAbTest';
import {selectFabricArt} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {useLiners} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Envelope/actions/useLiner';
import {Envelope as EnvelopeImage} from '~/CreateFabricInvitation/components/Envelope/Envelope';
import {Sections} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';
import {largishAndUp} from '~libSass/base/_exports.sass';
import {useMatchQuery} from '~library/hooks/useMatchQuery';

export const Envelope = () => {
  const {selectedLiner} = useLiners();
  const fabricArt = useSelector(selectFabricArt);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isInEditButtonTest = useInMwEditDesignButtonAbTest();

  return (
    <div
      className={cx('card-template envelope', {
        'onestep-edit-ABTest__card-wrapper': isInEditButtonTest,
      })}
    >
      <div className="envelope__images">
        <Card
          className="envelope__images__card"
          fabricArt={fabricArt}
          redirectTo={isDesktop ? Sections.CARD_DESIGN : null}
          parentNode={`${!isDesktop ? 'create-container' : ''}`}
        />
        <EnvelopeImage
          type="blank"
          className="envelope__images__envelope"
          selectedLiner={selectedLiner?.image}
          forceShowEnvelope
        />
      </div>
    </div>
  );
};
